import { render, staticRenderFns } from "./OrderHistoryItemList.vue?vue&type=template&id=a9024bfc&scoped=true&"
import script from "./OrderHistoryItemList.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryItemList.vue?vue&type=script&lang=js&"
import style0 from "./OrderHistoryItemList.vue?vue&type=style&index=0&id=a9024bfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9024bfc",
  null
  
)

export default component.exports